import { Navigate, Route, Routes } from 'react-router-dom';
import React, { Component } from 'react';
import Login from './app/login/login';
import Branch from './app/branch/branch';
import Programs from './app/programs/programs';
import Header from './app/shared/components/header/header';
import MenuLeft from './app/menu-left/menu-left';
import Program from './app/program/program'
import { ProtectedRoute, LoginRoute } from './app/auth/auth';
import DetailStudio from './app/detail-studio/detail-studio';
import ProgramHistory from './app/program-history/program-history';
// import ModalEditarClase from './app/shared/components/card-class-branch/modal-edit/modal-edit';

class Router extends Component {
    render() {
        return (
            <Routes>
                <Route path="/login" element={<LoginRoute> <Login /> </LoginRoute>}></Route>

                <Route path="/" element={<ProtectedRoute><Header /></ProtectedRoute>}>
                    <Route path="/branch" element={<Branch />} />
                    <Route path="/branch/:id" element={<MenuLeft />} />
                    <Route path="programs" element={<Programs />} />
                    <Route path="program/:id" element={<Program />} />
                    <Route path="program-history" element={<ProgramHistory />} />
                    <Route path="/detail-studio/:id" element={<DetailStudio />} />
                </Route>
                <Route
                    path="*"
                    element={<Navigate to="/branch" replace />}
                />
            </Routes>
        );
    }
}

export default Router; 